import React, { Component } from "react";
import { Row, Col, Grid } from "react-bootstrap";

import Sidebar from "../../Sidebar/Sidebar";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import AllEventsContent from "./AllEventsContent";

import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";
import BannerRectangle from "../../Banner/BannerRectangle";

import { Helmet } from "react-helmet";

import { getLanguage } from "../../Translation/Translation";
import { FETCH_URL } from "../../../utilities";

class AllEvents extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itineraries: null,
    };
  }

  searchItineraries = () => {
    const width = window.innerWidth;
    let range = 3;
    if (width < 1060) {
      range = 1;
    }

    return fetch(`${FETCH_URL}/proxy.php?ws=5a84eaef340463398015c41e8361c199`, {
      method: "POST",
      body: JSON.stringify({
        outgoingLocationCode: `${this.props.match.params.from}`,
        incomingLocationCode: `${this.props.match.params.to}`,
        outgoingDate: `${this.props.match.params.sdate}`,
        incomingDate: `${this.props.match.params.edate}`,
        languageCode: `${getLanguage()}`,
        includeEvents: true,
        dayRange: range,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ itineraries: responseJson });
        return responseJson;
      })
      .catch((error) => {
        console.error(error);
      });
  };

  componentDidMount() {
    this.searchItineraries();
  }

  render() {
    const {
      events,
      setEventsLocationCode,
      setEventsEventtypeId,
      setEventsMaxeventsSize,
      setDate,
      setEventsList,
    } = this.props.data;
    return (
      <div>
        <Grid fluid className="no-padding">
          <Helmet>
            <title>Local Events | Openseas</title>
            <meta
              name="description"
              content="Ανακαλύψτε συναυλίες,  θέατρο, φεστιβάλ, εκθέσεις, αθλητικά δρώμενα , χορός και τοπικές γιορτές σε όλη την Ελλάδα. Openseas, φροντίζει το σύγχρονο ταξιδιώτη. Δείτε τι μπορείτε να κάνετε στο επόμενο σας ταξίδι."
            />
          </Helmet>
          <Row style={{ margin: "0px" }}>
            <Col style={{ margin: "0px" }}>
              <Header data={this.props} />
            </Col>
          </Row>
          <Row>
            <div className="OSPageContainer">
              <div className="OSPageContent">
                <AllEventsContent
                  events={events}
                  setLocationCode={setEventsLocationCode}
                  setTypeId={setEventsEventtypeId}
                  setMaxEventsSize={setEventsMaxeventsSize}
                  setDate={setDate}
                  setEventsList={setEventsList}
                  language={getLanguage()}
                />
                <Row style={{ margin: "24px 0px 24px 0" }}>
                  <div className="displayBannerLarge">
                    <BannerRectangleLarge />
                  </div>
                </Row>
                <Row>
                  <Col xs={12} sm={6} mdHidden lgHidden>
                    <BannerRectangle />
                  </Col>
                  <Col xsHidden sm={6} mdHidden lgHidden>
                    <BannerRectangle />
                  </Col>
                </Row>
              </div>
              <div className="OSPageSidebar">
                <Sidebar />
              </div>
            </div>
          </Row>
          <Row style={{ margin: "0px" }}>
            <Footer />
          </Row>
        </Grid>
      </div>
    );
  }
}

export default AllEvents;



// WEBPACK FOOTER //
// ./src/components/Pages/Allevents/Allevents.js